import React, { useEffect, useState } from 'react';
import CollapseHeader from '../../core/common/collapse-header/collapse-header';
import { Link } from 'react-router-dom';
import { apibaseurl } from '../../environment';
import useApi from '../../core/customhook/useApi';


const UserGuide = () => {
    const [documents, setDocuments] = useState([]);

    const {
        data,
        error,
        loading: userguideLoading,
    } = useApi("/api/get-userguide", {
        method: "GET",
        autoCall: true,
    });

    console.log(data)

    useEffect(() => {
        if (data?.success) {
            setDocuments(data?.data)
        }
    }, [data])

    const handleDownload = async (filePath: string) => {
        try {
            const fileUrl = `${apibaseurl}${filePath}`;
            const fileName = filePath.split("/").pop() || "downloaded_file";

            const response = await fetch(fileUrl, {
                method: "GET",
                headers: {
                    // Add auth headers if needed, e.g.:
                    // Authorization: `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch file");
            }

            // Convert response to blob
            const blob = await response.blob();

            // Create temporary link element
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName; // Suggests file name to browser
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
            alert("Error downloading file. Please try again.");
        }
    };



    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">User Guides</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="#"><i className="ti ti-smart-home" /></Link>
                                </li>
                                <li className="breadcrumb-item">Administration</li>
                                <li className="breadcrumb-item active" aria-current="page">User Guides</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">

                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>

                    </div>
                </div>
                {/* /Breadcrumb */}

                <div className="card">
                    <div className="card-body p-3">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="align-items-center flex-wrap row-gap-3">
                                This module is designed to provide team members with comprehensive instructions for effectively setting and achieving their SMART goals.
                            </div>
                        </div>
                    </div>
                </div>

                {/* Documents Table */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th scope="col">Image</th>
                                                <th scope="col">Title</th>
                                                <th scope="col">Financial year</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documents.map((item: any) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <img src="https://team1consulting.com/weconnect/assets/img/icons/guide.png" alt="img" style={{ height: "70px" }} />
                                                    </td>
                                                    <td>{item.title}</td>
                                                    <td>{item.financial_year}</td>
                                                    <td>
                                                        <div className="hstack gap-2 fs-15">
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleDownload(item.file);
                                                                }}
                                                                className="btn btn-icon btn-sm btn-info d-flex align-items-center justify-content-center"
                                                                style={{ width: "30px", height: "30px" }}
                                                            >
                                                                <i className="feather-download" />
                                                            </a>

                                                            <a
                                                                href={`${apibaseurl}${item.file}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-icon btn-sm btn-primary d-flex align-items-center justify-content-center"
                                                                style={{ width: "30px", height: "30px" }}
                                                            >
                                                                <i className="feather-eye" />
                                                            </a>
                                                        </div>
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
            </div>


        </div>
    );
};

export default UserGuide;
